import styles from '../styles/rules.module.scss'
import rules from '../data/rules.json';

function Rules() {

  return (
    <div className={styles.rules}>
    {rules.rules.map((t, i) => {
      if (t.text) return (
        <div className={styles.info} key={i}>
          <h3>{t.title}</h3>
          <div dangerouslySetInnerHTML={{__html: t.text}} />
        </div>
      )
      if (t.body) return (
        <div className={styles.qa_list} key={i}>
        <h3>{t.title}</h3>
        { t.body.map((q, i) => <div className={styles.qa}>
        <div><span>{q.qTitle}</span> <p dangerouslySetInnerHTML={{__html: q.qMain}} /></div>
        <div><span>{q.anTitle}</span> <p dangerouslySetInnerHTML={{__html: q.anMain}} /></div>
        </div>)
        }
      </div>
        
      ) 
    })}
  </div>
  )
}

export default Rules
